/**
 * 移动端邮件营销活动详情页
 */
import React, { useEffect, useState } from 'react';
import {
  Card,
  List,
  PullToRefresh,
  Empty,
  Avatar,
  Skeleton,
  Statistic,
  Tag,
} from 'antd-mobile';
import { adminEmailCampaignApi } from '../../api/index';
import Toast from 'antd-mobile/es/components/toast';
import { useNavigate, useParams } from 'react-router-dom';
import { CheckCircleOutline, CloseCircleOutline, ClockCircleOutline } from 'antd-mobile-icons';

// 状态配置
const STATUS_CONFIG = {
  pending: { color: 'default', label: '待发送', icon: ClockCircleOutline },
  sent: { color: 'success', label: '已发送', icon: CheckCircleOutline },
  failed: { color: 'danger', label: '失败', icon: CloseCircleOutline },
  opened: { color: 'primary', label: '已打开', icon: CheckCircleOutline },
  clicked: { color: 'success', label: '已点击', icon: CheckCircleOutline },
};

export default function MobileEmailCampaignDetailPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [campaign, setCampaign] = useState(null);
  const [logs, setLogs] = useState([]);
  const [stats, setStats] = useState({});

  useEffect(() => {
    fetchDetail();
  }, [id]);

  const fetchDetail = async () => {
    try {
      const campaignData = await adminEmailCampaignApi.getById(id);
      setCampaign(campaignData);

      const statsData = await adminEmailCampaignApi.getStats(id);
      setStats(statsData);

      const logsData = await adminEmailCampaignApi.getLogs(id);
      setLogs(logsData || []);
    } catch (err) {
      Toast.show('获取详情失败');
    } finally {
      setLoading(false);
    }
  };

  const refreshData = async () => {
    await fetchDetail();
  };

  if (loading) {
    return (
      <div style={{ padding: 16 }}>
        <Skeleton.Title rows={3} />
        <Skeleton.Title rows={5} style={{ marginTop: 16 }} />
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', padding: 16 }}>
      <h2 style={{ fontSize: 18, fontWeight: 600, margin: '0 0 16px' }}>
        {campaign?.name || '活动详情'}
      </h2>

      {/* 统计卡片 */}
      <Card style={{ marginBottom: 16 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8 }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 12, color: '#999', marginBottom: 4 }}>总数</div>
            <div style={{ fontSize: 18, fontWeight: 600 }}>{campaign?.totalRecipients || 0}</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 12, color: '#52c41a', marginBottom: 4 }}>成功</div>
            <div style={{ fontSize: 18, fontWeight: 600, color: '#52c41a' }}>{campaign?.successCount || 0}</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 12, color: '#ff4d4f', marginBottom: 4 }}>失败</div>
            <div style={{ fontSize: 18, fontWeight: 600, color: '#ff4d4f' }}>{campaign?.failedCount || 0}</div>
          </div>
        </div>
      </Card>

      {/* 发送记录 */}
      <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>发送记录</div>
      <PullToRefresh onRefresh={refreshData}>
        {logs.length > 0 ? (
          <List>
            {logs.map((log) => {
              const statusConfig = STATUS_CONFIG[log.status] || STATUS_CONFIG.pending;
              const StatusIcon = statusConfig.icon;
              return (
                <List.Item
                  key={log.id}
                  style={{
                    background: '#fff',
                    marginBottom: 12,
                    padding: '12px 16px',
                  }}
                  description={
                    <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                      {log.sentAt ? new Date(log.sentAt).toLocaleString('zh-CN') : '-'}
                      {log.errorMessage && <div style={{ color: '#ff4d4f', marginTop: 4 }}>{log.errorMessage}</div>}
                    </div>
                  }
                  prefix={
                    <Avatar
                      style={{ '--background': statusConfig.color === 'success' ? '#52c41a' : statusConfig.color === 'danger' ? '#ff4d4f' : '#1677ff' }}
                    >
                      <StatusIcon style={{ fontSize: 16, color: '#fff' }} />
                    </Avatar>
                  }
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontSize: 14 }}>{log.customerEmail}</div>
                    <Tag color={statusConfig.color} size="small">
                      {statusConfig.label}
                    </Tag>
                  </div>
                </List.Item>
              );
            })}
          </List>
        ) : (
          <div style={{ padding: '80px 0' }}>
            <Empty description="暂无发送记录" />
          </div>
        )}
      </PullToRefresh>
    </div>
  );
}
